import React from "react";

export const CloseIcon = () => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5 5.50004L10.5 10.5L5.50004 15.5M5.5 5.5L15.5 15.5"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
